import { useState } from 'react'
import { RebalanceType, TaxDetails } from '../../../types/rebalance'
import WithdrawalAmountAndExitLoad from './WithdrawalAmountAndExitLoad'
import TaxLiabilityAccordion from './TaxLiabilityAccordion'
import ExitLoadAndTaxInfo from './ExitLoadAndTaxInfo'
import { TaxCategories } from '../../../types/mutual-fund-detail.types'

type ExitLoadAndTaxProps = Partial<TaxDetails> & {
  rebalanceStrategyType?: RebalanceType
  isHighExposureFund?: boolean
  highExposureTransferAmount?: number
  isElss?: boolean
  currentWealth?: number
  isRegularFund?: boolean
}

export default function ExitLoadAndTax({
  taxCategory,
  isHighExposureFund = false,
  isElss = false,
  currentValue = 0,
  exitLoad = 0,
  netTaxLiability = 0,
  stcgTaxInfo = { taxRate: 0, investedAmount: 0, gains: 0, taxableAmount: 0 },
  ltcgTaxInfo = { taxRate: 0, investedAmount: 0, gains: 0, taxableAmount: 0 },
  highExposureTransferAmount = 0,
  currentWealth = 0,
  isRegularFund = false
}: ExitLoadAndTaxProps = {}) {
  const [accordionOpen, setAccordionOpen] = useState(false)
  const withdrawalAmount = currentValue

  return (
    <div className='bg-white py-8'>
      <div className='flex flex-col gap-4'>
        <div className='flex flex-col'>
          <h1 className='text-[#232323] text-[18px] font-[400] px-5'>Exit Load & Tax Liability</h1>
        </div>
        <div className='flex flex-col gap-2'>
          <WithdrawalAmountAndExitLoad withdrawalAmount={withdrawalAmount} exitLoad={exitLoad} />
          <TaxLiabilityAccordion
            accordionOpen={accordionOpen}
            setAccordionOpen={setAccordionOpen}
            netTaxLiability={netTaxLiability}
            stcgTaxInfo={stcgTaxInfo}
            ltcgTaxInfo={ltcgTaxInfo}
            taxCategory={taxCategory as `${TaxCategories}`}
          />
        </div>
        <ExitLoadAndTaxInfo
          isHighExposureFund={isHighExposureFund}
          isElss={isElss}
          highExposureTransferAmount={highExposureTransferAmount}
          withdrawalAmount={withdrawalAmount}
          currentWealth={currentWealth}
          isRegularFund={isRegularFund}
        />
      </div>
    </div>
  )
}
